import React from 'react';
import { connect } from 'react-redux';

import PrivateRoute from './PrivateRoute';

import { selectIsAuthenticated } from '../../redux/auth/user/selectors';

const PrivateRouteConnected = (props) => <PrivateRoute {...props} />;

const mapStateToProps = (state, props) => ({
  isAuthenticated: selectIsAuthenticated(state, props),
});

export default connect(mapStateToProps)(PrivateRouteConnected);
